import ErrorPage from './default';
import { ALREADY_PURCHASE_PROMO_TV as TEXTS } from './constants';

function AlreadyPurchaseTv(props) {
  return (
    <ErrorPage
      {...props}
      title={TEXTS.TITLE}
      description={TEXTS.DESCRIPTION}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={TEXTS.BUTTON_TEXT}
      buttonHref={TEXTS.BUTTON_HREF}
      showLink={false}
      componentContent="already-purchase-promo-tv"
      columnForm
    />
  );
}
export default AlreadyPurchaseTv;
